<script setup>
import {useFormErrors} from "vee-validate";
import {computed} from "vue";
import {uniq} from "lodash";

const formErrors = useFormErrors();

const props = defineProps({
  errors: {
    type: [Array],
    default(){
      return [];
    },
  },
  submitted: {
    type: Boolean,
    default: false,
  }
})

const errorList = computed(() => {

  let formErrorsList = []

  if (props.submitted){
    formErrorsList = Object.values(formErrors.value)
    formErrorsList = Array.isArray(formErrorsList) ? formErrorsList : []
  }

  let otherErrors = props.errors;
  otherErrors = Array.isArray(otherErrors) ? otherErrors : []

  return uniq([...otherErrors, ...formErrorsList])
})

</script>

<template>
  <div>
    <div
        v-if="errorList.length > 0"
        class="bg-red-200 p-4 px-6 rounded text-sm mb-2"
    >
      <div
          v-for="(errorItem, ind) in errorList"
          :key="`submit-quote-error-${ind}`"
          v-text="errorItem"
      ></div>
    </div>
  </div>
</template>

<style scoped>

</style>